export default {
  isAuthenthicated: state => !!state.userID,
}
